import { Culture } from '../../types';

export const havasupai: Culture = {
  name: 'Havasupai Tribe',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Havasupai',
      phonetic: 'hah-vah-soo-pie',
      description: 'Means "People of the Blue-Green Water."'
    },
    {
      word: 'Matavi',
      phonetic: 'mah-tah-vee',
      description: 'Word for "water" in Havasupai.'
    },
    {
      word: 'Weelaba',
      phonetic: 'wee-lah-bah',
      description: 'Havasupai term meaning "cliff" or "canyon wall."'
    }
  ]
};